import { useQuery } from '@tanstack/react-query';
import { accountApi } from '@portal/api/account/accountApi';

interface CurrentUser {
  id: string;
  name: string;
  email: string;
}

export function useCurrentUser() {
  const { data: accountData, isLoading, error, refetch } = useQuery({
    queryKey: ['currentUser'],
    queryFn: () => accountApi.getAccount(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry on 401/403 errors
    throwOnError: false, // Don't throw errors, let components handle them
  });

  // Transform account data to CurrentUser format
  const currentUser: CurrentUser | null = accountData ? {
    id: accountData.id,
    name: accountData.profile ? `${accountData.profile.firstName} ${accountData.profile.lastName}`.trim() : 'User',
    email: accountData.email,
  } : null;

  // Debug logging
  if (!isLoading) {
    console.log('[useCurrentUser] Current user:', currentUser);
    console.log('[useCurrentUser] Error:', error);
  }

  return { currentUser, isLoading, refetch };
}